import { render, staticRenderFns } from "./PhoneSettingsModal.vue?vue&type=template&id=643394f0&scoped=true&"
import script from "./PhoneSettingsModal.vue?vue&type=script&lang=js&"
export * from "./PhoneSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643394f0",
  null
  
)

export default component.exports